import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const { phone } = capsuleValidation;

const initialValues = () => {
  return {
    phone_number: '',
  };
};

const validation = {
  initialValues,
  schema: Yup.object().shape({
    phone_number: phone().required(FORM_VALIDATION_ERRORS.mobilePhone),
  }),
};

export { validation };
